import React from 'react'

const AWS = () => {
  return (
    <div>
        {/* collapseFourtyFive */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFourtyFive">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourtyFive" aria-expanded="false" aria-controls="collapseFourtyFive">
                    AWS
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFourtyFive" className="accordion-collapse collapse" aria-labelledby="headingFourtyFive" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Ec2 Instances - Elastic Compute Cloud</strong>
                    <ul>
                        <li>Types of EC2</li>
                        <li>LifeCycle of EC2 Instances</li>
                        <li>AMI, EC2 Image Builders</li>
                        <li>SPOT, Reserved, ON-Demand Instances</li>
                    </ul>
                    <strong>EC2 Networking</strong>
                    <ul>
                        <li>Regions, Availability Zones</li>
                        <li>VPC</li>
                        <li>Security Groups</li>
                        <li>ACL</li>
                        <li>Internet Gateway, NAT Gateway</li>
                        <li>SSH Access</li>
                        <li>Elastic IP, Public IP</li>
                    </ul>
                    <strong>Instance Store</strong><br/>
                    <strong>EBS - Elastic Block Storage</strong>
                    <ul>
                        <li>Volumes, Snapshots & Encryption</li>
                        <li>IOPS & gp EBS</li>
                    </ul>
                    <strong>Project 1 - LAMP / LEMP Server</strong><br/>
                    <strong>Monitoring & Logging</strong>
                    <ul>
                        <li>CloudWatch</li>
                        <li>Cloud Trail</li>
                    </ul>
                    <strong>S3 - Simple Storage Service</strong>
                    <ul>
                        <li>Buckets & Objects</li>
                        <li>Types of S3 Storage Class</li>
                        <li>Lifecycle of S3</li>
                        <li>S3 Webhosting</li>
                        <li>S3 Versioning</li>
                        <li>S3 Encryption</li>
                    </ul>
                    <strong>RDS</strong>
                    <ul>
                        <li>Need & Configuration</li>
                        <li>MYSQL in RDS</li>
                        <li>Backup & Snapshots</li>
                        <li>Master & Read Replica</li>
                        <li>DB Encryption</li>
                        <li>Aurora - MYSQL Aurora</li>
                    </ul>
                    <strong>Project 2 - DB Form</strong><br/>
                    <strong>MultiAZ Deployment</strong><br/>
                    <strong>Autoscaling</strong><br/>
                    <strong>ELB - Elastic Load Balancer</strong>
                    <ul>
                        <li>ALB - Application Load Balancer</li>
                        <li>NLB - Network Load Balancer</li>
                        <li>CLB - Classic Load Balancer</li>
                    </ul>
                    <strong>High Availability</strong><br/>
                    <strong>Fault Tolerant</strong><br/>
                    <strong>Resiliencym</strong><br/>
                    <strong>MultiTier Archietecture</strong><br/>
                    <strong>Project 3 - Autoscaling & Load Balancing</strong><br/>
                    <strong>Lightsail</strong><br/>
                    <strong>EFS - Elastic File System</strong>
                    <ul>
                        <li>EFS Backup & Replication</li>
                        <li>EFS Encryption</li>
                    </ul>

                    <strong>DynamoDB</strong><br/>
                    <strong>NON - SQL DB</strong><br/>
                    <strong>Partition Key, Sort Key</strong><br/>
                    <strong>DynamoDB Global Tables</strong><br/>
                    <strong>DAX</strong><br/>
                    <strong>DynamoDB Encryption</strong><br/>
                    <strong>Project 4 DynamoDB Project</strong><br/>

                    <strong>IAM</strong>
                    <ul>
                        <li>IAM Users, Groups</li>
                        <li>IAM Roles</li>
                        <li>IAM Policies & Permissions</li>
                        <li>IAM Access Analyser</li>
                        <li>Access Key & Secret Key</li>
                        <li>AWS Organization</li>
                    </ul>

                    <strong>Route 53</strong>
                    <ul>
                        <li>DNS Management</li>
                        <li>Hosting Zones</li>
                        <li>Domain Listings</li>
                        <li>ACM Certificates</li>
                        <li>Route 54 Load Balancing</li>
                    </ul>

                    <strong>Decoupling</strong>
                    <ul>
                        <li>Microservices</li>
                        <li>Amazon SNS</li>
                        <li>Amazon SQS</li>
                    </ul>

                    <strong>Lambda</strong>
                    <ul>
                        <li>Serverless</li>
                        <li>Lambda Functions</li>
                        <li>Function Scaling & Managing</li>
                        <li>Lambda Runtime</li>
                        <li>Lambda Networking</li>
                    </ul>

                    <strong>Amazon Kinesis</strong>
                    <ul>
                        <li>Kinesis Data Streams</li>
                        <li>Kinesis Data Analytics</li>
                        <li>RedShift</li>
                        <li>Athena</li>
                    </ul>

                    <strong>AWS Storage Gateway</strong><br/>
                    <strong>AWS Snow Family</strong><br/>
                    <strong>AWS Direct Connect</strong><br/>
                    <strong>AWS VPN</strong><br/>
                    <strong>AWS Developer Tools</strong><br/>

                    <ul>
                        <li>CodeBuild, CodePipeline, CodeCommit</li>
                    </ul>

                    <strong>AWS KMS - Key Management Services</strong><br/>
                    <strong>Cloud Formation</strong><br/>
                    
                    <ul>
                        <li>IaC - Infrastructure as Code</li>
                        <li>CloudFormation Templates & Stacks</li>
                        <li>YAML & JSON</li>
                    </ul>

                    <strong>AWS CLI</strong><br/>
                    <strong>AWS SDK</strong><br/>
                    <strong>AWS Billing - Cost Optimization</strong><br/>
                    <strong>Hybrid Cloud</strong><br/>
                    <strong>Migate on - permises to AWS Cloud</strong><br/>
                    <strong>DevOps Tools Introduction</strong><br/>


                </div>
            </div>
        </div>
    </div>
  )
}

export default AWS